import { PickingInfo } from '@deck.gl/core/typed';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Filters } from 'app/types/types';
import { Bbox } from 'ais-facade-api/api';

const initialState = {
  bbox: {} as Bbox,
  filters: {} as Filters,
  hoveredTarget: {} as PickingInfo,
  mode: null as string | null,
  tools: {
    ruler: false,
  },
  isVesselPlaybackActive: false,
};

export const mapStateSlice = createSlice({
  name: 'mapState',
  initialState: initialState,
  reducers: {
    setBbox: (state, action: PayloadAction<any>) => {
      state.bbox = action.payload;
    },
    setHoveredTarget: (state, action: PayloadAction<any>) => {
      state.hoveredTarget = action.payload;
    },
    setFilters: (state, action: PayloadAction<any>) => {
      state.filters = action.payload;
    },
    setMode: (state, action: PayloadAction<any>) => {
      state.mode = action.payload;
    },
    setRulerTool: (state, action: PayloadAction<any>) => {
      state.tools.ruler = action.payload;
    },
    toggleIsVesselPlaybackActive: (state) => {
      state.isVesselPlaybackActive = !state.isVesselPlaybackActive;
    },
    setIsVesselPLaybackActive: (state, action: PayloadAction<any>) => {
      state.isVesselPlaybackActive = action.payload;
    },
  },
});
export const {
  setBbox,
  setHoveredTarget,
  setFilters,
  setMode,
  setRulerTool,
  toggleIsVesselPlaybackActive,
  setIsVesselPLaybackActive,
} = mapStateSlice.actions;
export default mapStateSlice.reducer;
